module.exports = __webpack_public_path__ + "static/media/uhm-logo.920c8dcb.png";